import { BOOKING } from '../../reduxs'

const initialState = {
  list: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case BOOKING.actionType.SAVE_LIST_BOOKING:
      return {
        ...state,
        list: action.data.list
      }

    case BOOKING.actionType.CLEAR_LIST_BOOKING:
      return {
        ...initialState
      }

    default:
      return state
  }
}
